<template>
  <div>
    <DxForm id="formularioGrupoRetrocomisionEnergia" :form-data="model" label-location="top" :show-colon-after-label="false"
      validation-group="validacionGrupoRetrocomisionEnergia">
      <DxSimpleItem data-field="FechaInicio" editor-type="dxDateBox" :editor-options="{ type: 'date' }">
        <DxLabel :text="$t('retrocomisiones.grupo.creacion.fecha_inicio')" />
        <DxRequiredRule :message="$t('retrocomisiones.grupo.validacion.fecha_inicio')" />
      </DxSimpleItem>
    </DxForm>
    <p class="texto-light mt-3 mb-0">
      {{ $t("retrocomisiones.grupo.creacion.texto_informativo") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, reactive } from "vue";
import { DxForm, DxLabel, DxRequiredRule, DxSimpleItem } from "devextreme-vue/form";
import validationEngine from "devextreme/ui/validation_engine";
import { useModalBuilder } from "@helpers/modal-building-helper";
import { messageBoxResult } from "@components/dialogs/message-box";
import { useApi } from "@api/integration";
import { useIntl } from "@services/i18n";
import { toastError, toastSuccess } from "@/.shared/services/notification-service";
import { toUTCDateOnly } from "@/.shared/helpers/date-parser-helper";
import type { CreateGrupoCriterioRetrocomisionEnergiaModel } from "@api/api";
import type { DxButton } from "devextreme-vue";
import type { ToolbarReference } from "@helpers/modal-building-helper";
import { ApiError } from "@/.shared/services/http";

const props = defineProps({
  idEmpresaServicios: {
    type: String,
    required: true
  }
});

const api = useApi();
const intl = useIntl();

const model = reactive<CreateGrupoCriterioRetrocomisionEnergiaModel>({
  FechaInicio: new Date()
});

onMounted(() => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);

  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;
  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  okButton.update(w => w.text = `${intl.i18n.t("shared.ui.buttons.save")}`);
  okButton.update(w => w.onClick = async () => {
    const idGrupo = await guardar();
    if (idGrupo)
      modal.close(idGrupo);
  });
  cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
});

const guardar = async (): Promise<string | false> => {
  const result = validationEngine.validateGroup("validacionGrupoRetrocomisionEnergia");
  if (!result.isValid)
    return false;

  try {
    const idGrupo = await api.callStandardApi(
      "createGrupoCriterioRetrocomisionEnergia",
      { showLoading: true },
      props.idEmpresaServicios,
      { FechaInicio: toUTCDateOnly(model.FechaInicio) }
    );
    toastSuccess(intl.i18n.t("retrocomisiones.grupo.creacion_exito"));
    return idGrupo;
  } catch (error) {
    if (error instanceof ApiError) {
      toastError(intl.i18n.t(`shared.errors.api.${error.details.errorList[0].Code}`));
    } else {
      toastError(intl.i18n.t("retrocomisiones.grupo.creacion_fallo"));
    }
    return false;
  }
};

</script>

<style lang="scss" scoped></style>
